import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Switch } from 'react-router-dom';
import { menuExit, hideSiteIntro, pageChange, fetchJSONByPath } from 'actions';
import Rainbow from 'components/common/Rainbow';
import Err from 'components/Pages/Err/Err';
import get from 'lodash/get';
import { mapPathnameToStore, routes } from 'routes';

import { renderRoutes } from 'react-router-config';

class Pages extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			pending: false,
			error: false,
			cache: props
		};

		// if prepopulated state says error, sets state.error immediately
		// so that Err is rendered
		if(props.fetched === 'error'){
			this.state.error = true;
		}
	}
	fetchPage = (pathname) => {
		// console.log('Pages.fetchPage('+pathname+')');
		this.setState({ pending: true });
		this.props.fetchJSONByPath(pathname);
	}
	changePage = () => {
		// console.log('Pages.changePage()');
		this.setState({
			pending: false,
			error: false,
			cache: this.props
		});
		window.scrollTo(0, 0);
		this.props.onPageChange( this.props.location.pathname );
	}
	errorPage = () => {
		this.setState({
			pending: false,
			error: true,
			cache: this.props
		});
		window.scrollTo(0, 0);
		this.props.onPageChange( this.props.location.pathname );
	}
	componentDidMount() {
		// only fetch if it is not fetched, for SSR
		switch(this.props.fetched){
			case 'success':
				break;
			case 'error':
				this.errorPage();
				break;
			default:
				this.fetchPage( this.props.location.pathname );
				break;
		}
	}
	componentDidUpdate(prevProps) {
		const prevPathname = prevProps.location.pathname;
		const newPathname = this.props.location.pathname;

		if (prevPathname !== newPathname) {
			if ( this.props.fetched === 'success' ) {
				this.changePage();
			} else {
				this.fetchPage( newPathname );
			}
		} else if ( this.props.fetched !== prevProps.fetched ) {
			if ( this.props.fetched === 'success' ) {
				this.changePage();
			} else if ( this.props.fetched === 'error' ) {
				this.errorPage();
			}
		}
	}
	render() {
		return (
			<div id="Pages">
				<Switch location={this.state.cache.location}>
					{ renderRoutes( routes ) }
				</Switch>
				{ this.state.error && <Err /> }
				{ this.state.pending && <Rainbow /> }
			</div>
		)
	}
}
const mapStateToProps = (state, ownProps) => {
	const stored = mapPathnameToStore( ownProps.location.pathname );
	const query = stored.concat( 'status' );
	return {
		fetched: get( state.fetcher, query, false )
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		fetchJSONByPath: (pathname) => {
			dispatch( fetchJSONByPath(pathname) )
		},
		onPageChange: (pathname) => {
			dispatch( menuExit() );
			dispatch( hideSiteIntro() );
			dispatch( pageChange( pathname ) );
		}
	}
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Pages));


// WEBPACK FOOTER //
// ./src/components/Pages.jsx